import classes from "./Contactus.module.css";
import { useRef, useState } from "react";
import { FaRegWindowClose, FaCheckCircle, FaWhatsapp } from "react-icons/fa";

function Contactus() {
  const fullNameInputRef = useRef();
  const emailInputRef = useRef();
  const contactNoInputRef = useRef();
  const messageInputRef = useRef();
  const [isSubmitInProgress, setIsSubmitInProgress] = useState(false);

  const [error, setError] = useState(null);
  const errorDiv = error ? (
    <div className="error">
      <FaRegWindowClose size={20} color="red" />{" "}
      {error}
    </div>
  ) : (
    ""
  );

  const [sendStatus, setSendStatus] = useState(null);
  const sendStatusDiv = sendStatus ? (
    <div className="success">
      <FaCheckCircle size={20} color="green" /> {sendStatus}
    </div>
  ) : (
    ""
  );

  function clearForm() {
    fullNameInputRef.current.value = "";
    emailInputRef.current.value = "";
    contactNoInputRef.current.value = "";
    messageInputRef.current.value = "";
  }
  function submitHandler(event) {
    setIsSubmitInProgress(true);
    event.preventDefault();

    setSendStatus (null);
    setError (null);

    const enteredFullName = fullNameInputRef.current.value;
    const enteredEmail = emailInputRef.current.value;
    const enteredContactNo = contactNoInputRef.current.value;
    const enteredMessage = messageInputRef.current.value;

    const enqueryMail = {
      FullName: enteredFullName,
      ContactEmailId: enteredEmail,
      ContactNo: enteredContactNo,
      EnquiryMessage: enteredMessage,
    };

    console.log(enqueryMail);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(enqueryMail),
    };

    fetch(`${process.env.PUBLIC_URL}/api/email/enquiry`, requestOptions)
      .then(async (response) => {
        const isJson = response.headers
          .get("content-type")
          ?.includes("application/json");
        const data = isJson && (await response.json());
        console.log("data", data);
        console.log("response", response);
        // check for error response
        if (!response.ok) {
          // get error message from body or default to response status
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        } else {
          setSendStatus(
            "Your Enquiery has been sumbitted. Our team will contact you shortly!"
          );
          clearForm();
          console.log("inside success!");
        }
      })
      .catch((error) => {
        setError(
          "Could not submit your request due to some technical issue. Please try after some time!"
        );
        console.error("There was an error!", error);
      });
    setIsSubmitInProgress(false);
    console.log("Send Mail");
  }

  return (
    <div className={classes.pageWrapper}>
      <div className={classes.pageHeader}>
        <header>Contact Us</header>
      </div>

      <div className={classes.contactLayout}>
        {/* Info column */}
        <div className={classes.infoCard}>
          <div className={classes.infoBlock}>
            <h3>Address</h3>
            <p>First Number Furniture LLC</p>
            <p>Industrial Area 13, Plot No 231</p>
            <p>Shed 12, Street No 13</p>
            <p>Sharjah, U.A.E. — P.O. Box: 84209</p>
          </div>
          <div className={classes.infoBlock}>
            <h3>Email</h3>
            <a href="mailto:info@firstnumberfurniture.com?subject=Enquiry&body=Hello,">
              info@firstnumberfurniture.com
            </a>
          </div>
          <div className={classes.infoBlock}>
            <h3>Phone</h3>
            <a href="tel:0559744760">0559744760</a>
          </div>
          <div className={classes.infoBlock}>
            <h3>WhatsApp</h3>
            <a href="https://wa.me/971559744760" target="_blank" rel="noopener noreferrer" className={classes.whatsappLink}>
              <FaWhatsapp size={22} color="#25D366" /> 0559744760
            </a>
          </div>
        </div>

        {/* Form column */}
        <div className={classes.formCard}>
          <form className={classes.form} onSubmit={submitHandler}>
            <div className={classes.control}>
              <label htmlFor="fullName">Full Name</label>
              <input type="text" required id="fullName" ref={fullNameInputRef} />
            </div>
            <div className={classes.control}>
              <label htmlFor="email">Email</label>
              <input type="email" required id="email" ref={emailInputRef} />
            </div>
            <div className={classes.control}>
              <label htmlFor="contactNo">Contact Number</label>
              <input type="text" required id="contactNo" ref={contactNoInputRef} />
            </div>
            <div className={classes.control}>
              <label htmlFor="message">Message</label>
              <textarea id="message" required rows="6" ref={messageInputRef}></textarea>
            </div>
            {errorDiv}
            {sendStatusDiv}
            <div className={classes.actions}>
              <button disabled={isSubmitInProgress}>
                {isSubmitInProgress ? "Sending…" : "Send Message"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contactus;
